import React, { useEffect, useState } from "react";
import GalleryExplorer from "../component/GalleryExplorer";
import { fetchgalleryapi } from "../api/fetchgalleryapi";

function Gallery() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchgalleryapi()
      .then((data) => active && setCollections(Array.isArray(data) ? data : []))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  return (
    <div className="container py-3">
      <GalleryExplorer collections={collections} loading={loading} />
    </div>
  );
}

export default Gallery;
